(function()  {

    'use strict';

    /**
     * Initiates the donations object
     */
    const Metric = function (element) {

        this.element = element;
        this.radius = 20;
        this.marks = element.getElementsByClassName('mark');

        this.initiateObserver();
    };

    /**
     * Start observing
     */
    Metric.prototype.initiateObserver = function () {

        const observer = new ResizeObserver(function (entries) {

            entries.forEach(function (entry) {

                if (entry.contentBoxSize) {

                    this.width = entry.contentBoxSize[0].inlineSize;
                    this.height = entry.contentBoxSize[0].blockSize;

                    this.prepareView();
                }

            }.bind(this));
        }.bind(this));

        observer.observe(this.element);
    };

    /**
     * Sets the view box for the donation view
     */
    Metric.prototype.setViewBox = function () {
        this.element.setAttribute('width', this.width);
        this.element.setAttribute('height', this.height);
        this.element.setAttribute('viewbox', `0 0 ${this.width} ${this.height}`);
    };

    /**
     * Prepares the donation view
     */
    Metric.prototype.prepareView = function () {

        this.setViewBox();
        this.layoutBar();
    };

    /**
     * Sets the bars
     */
    Metric.prototype.layoutBar = function () {

        let backBar = this.marks[0];
        backBar.setAttribute('d', this.drawRectangle(this.width, this.height));

        let total = Number(backBar.textContent);

        let frontBar = this.marks[1];

        let value = Number(frontBar.textContent);

        const length = Math.ceil(value * (this.width / total));

        frontBar.setAttribute('d', this.drawRectangle(length, this.height));
    };

    /**
     * Draws the bars for the linear progress
     */
    Metric.prototype.drawRectangle = function (length, height) {

        let radius = Math.min(this.radius, height / 2);

        let commands = [];

        commands.push(`M 0 ${radius}`);
        commands.push(`q 0,-${radius} ${radius},-${radius}`);
        commands.push(`H ${length - radius}`);
        commands.push(`q ${radius},0 ${radius},${radius}`);
        commands.push(`V ${height - radius}`);
        commands.push(`q 0,${radius} -${radius},${radius}`);
        commands.push(`H ${radius}`);
        commands.push(`q -${radius},0 -${radius},-${radius}`);
        commands.push(`Z`);

        return commands.join(' ');
    };

    const metrics = document.getElementsByClassName('js-metric');

    for (const metric of metrics) {
        new Metric(metric);
    }

}());